import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IGenericFormLoader } from '../../interfaces/form-label';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { DateFormat } from '../../interfaces/base-core-services.interface';
import { DateTimeService } from '../../services/date-time.service';

@Component({
  selector: 'lib-approval',
  templateUrl: './risk-ass-info-approval.html',

})

export class RiskASSApprovalComponent implements OnInit, IGenericFormLoader {
  public approvalStatusList:any[] = [];
  public recommendedOutcomeList:any[]= [];
    @Input() public defaultFormData: string[];
    @Output() public  submitedFormData = new EventEmitter<FormData>();
    public actions: string[] = [];
    public RISKASSApprovalForm: FormGroup;
    public actionApprove = false;
    public appRemarks = false;
    public onHold = false;
    public useBy = false;
    public formData:any = { 'variables': {} };
    public load = false;
    public RemarksMaxLength = 50;
    public onholdRange = new Date();
    public onbyRange = new Date();
    constructor(private formBuilder: FormBuilder, private dateTimeService: DateTimeService) { }

    ngOnInit():void {

      if (typeof this.defaultFormData === 'object') {
        this.onLoad(this.defaultFormData);
        this.load = true;
      }
    }

    /**
   * A - Approval, R - Reject, M - MoreInfo
   * @param defaults | ARMC
   */
    onLoad(data:any) :void{
      // this.actions = this.prepareActions(data);
      this.RISKASSApprovalForm = this.formBuilder.group({
        approvalStatus: ['', [Validators.required]],
        approvalRemarks:  ['', [Validators.maxLength(this.RemarksMaxLength)]],
        internalRemarks: ['', [Validators.maxLength(this.RemarksMaxLength)]],
        recommendedOutcome: [''],
        useByDate: [''],
        useTillDate: ['']

      });
      const keys = Object.keys(data.rdmData);
      keys.forEach((key) => {

        if (key.indexOf('approval') >= 0) {
          this.approvalStatusList = data.rdmData[key];
        } else {
          this.recommendedOutcomeList = data.rdmData[key];
        }
      });
    }


    recommendedOutcomeChange(value: string):void {
      if (value == 'Put on Hold') {
        this.onHold = true;
        this.useBy = false;
      } else if (value == 'Future usage') {
        this.useBy = true;
        this.onHold = false;
      } else {
        this.onHold = false;
        this.useBy = false;
      }
    }

    approvalStatusChange(value: string):void {
      this.onHold = false;
      this.useBy = false;
      this.formData = { 'variables': {} };
      const aMarks:any = this.RISKASSApprovalForm.get('approvalRemarks');
      aMarks.setValue('');
      if (value == 'Approve') {
        this.actionApprove = true;
      } else {
        this.actionApprove = false;
      }

    }


    onChangeholdTill(result: Date): void {
      // eslint-disable-next-line no-console
      console.log(this.dateTimeService.getDateFormat(result, DateFormat.YYYY_MM_DD));
      this.RISKASSApprovalForm.controls['useTillDate'].setValue(this.dateTimeService.getDateFormat(result, DateFormat.MM_DD_YYYY));
    }

    onChangeuseBy(result: Date): void {
      // eslint-disable-next-line no-console
      console.log(this.dateTimeService.getDateFormat(result, DateFormat.YYYY_MM_DD));
      this.RISKASSApprovalForm.controls['useByDate'].setValue(this.dateTimeService.getDateFormat(result, DateFormat.MM_DD_YYYY));
    }

    onSubmit():void {

      for (const i in this.RISKASSApprovalForm.controls) {
        if(i in this.RISKASSApprovalForm.controls){
          this.RISKASSApprovalForm.controls[i].markAsDirty();
          this.RISKASSApprovalForm.controls[i].updateValueAndValidity();
        }
      }

      // eslint-disable-next-line no-console
      console.log('out length', this.RISKASSApprovalForm.value.recommendedOutcome.length);
      if (this.RISKASSApprovalForm.value.approvalStatus.length > 0) {
        this.formData.variables['status'] = { 'value': this.RISKASSApprovalForm.value.approvalStatus };
      }
      if (this.RISKASSApprovalForm.value.recommendedOutcome) {
        this.formData.variables['actionRemarks'] = { 'value': this.RISKASSApprovalForm.value.recommendedOutcome };
      }

      if (this.RISKASSApprovalForm.value.internalRemarks.length > 0) {
        this.formData.variables['reveiwerRemarks'] = { 'value': this.RISKASSApprovalForm.value.internalRemarks };
      }
      if (this.RISKASSApprovalForm.value.internalRemarks.length > 0) {
        this.formData.variables['actionType'] = { 'value': this.RISKASSApprovalForm.value.approvalStatus };
      }
      if (this.RISKASSApprovalForm.value.useByDate) {
        this.formData.variables['useBy'] = { 'value': this.RISKASSApprovalForm.value.useByDate };
      }
      if (this.RISKASSApprovalForm.value.useTillDate) {
        this.formData.variables['onHoldTill'] = { 'value': this.RISKASSApprovalForm.value.useTillDate };
      }

      if (this.RISKASSApprovalForm.valid) {
        this.submitedFormData.emit(this.formData);
      }

    }

    numberOnly(event:any): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
}
